import { Injectable } from "@angular/core";
import { DashboardSettingsInterface } from "../../models/dashboard-settings.interface";

@Injectable({
  providedIn: "root",
})
export class LayoutService {
  // theme layout settings
  public config: DashboardSettingsInterface = {
    settings: {
      sidebar: "compact-wrapper",
      layout_type: "ltr",
      layout_version: "light",
      sidebar_type: "default-sidebar",
    },
    color: {
      primary_color: "rgb(255, 105, 180)",
      secondary_color: "rgb(255, 197, 0)",
    },
  };

  constructor() {
    this.runLayout_type();
  }
  runLayout_type() {
    // layout condition
    if (this.config.settings.layout_type == "rtl") {
      //side bar config
      document
        .getElementsByTagName("html")[0]
        .setAttribute("dir", this.config.settings.layout_type);
      document.documentElement.style.setProperty(
        "--theme-deafult",
        this.config.color.primary_color
      );
      document.documentElement.style.setProperty(
        "--theme-secondary",
        this.config.color.secondary_color
      );
    } else {
      if (this.config.settings.layout_type == "box-layout") {
        document.body.classList.add("box-layout");
      }
    }
  }
}
